import React, { useState, useContext, useEffect, useRef } from "react";
import clsx from "clsx";
import moment from "moment";
import {
  makeStyles,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  MenuItem,
  IconButton,
  Menu,
  Avatar,
  Tooltip,
  Button,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

import MainListItems from "./MainListItems";
import NotificationsPopOver from "../components/NotificationsPopOver";
import UserModal from "../components/UserModal";
import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import { i18n } from "../translate/i18n";
import toastError from "../errors/toastError";
import AnnouncementsPopover from "../components/AnnouncementsPopover";

import logo from "../assets/duo-lockup-bar.svg";
import logoWhite from "../assets/duo-lockup-horizontal-dark.svg";
import { socketConnection } from "../services/socket";
import ChatPopover from "../pages/Chat/ChatPopover";

//import { useDate } from "../hooks/useDate";

import ColorModeContext from "../layout/themeContext";
import { MenuOpen } from "@material-ui/icons";

import CloseIcon from "@material-ui/icons/Close";
import useCompanies from "../hooks/useCompanies";
import Blocked from "../pages/Blocked";

const drawerWidth = 295;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    [theme.breakpoints.down("sm")]: {
      // height: "calc(100vh - 56px)",
      height: "calc(100vh)",
    },
    backgroundColor: theme.palette.fancyBackground,
    '& .MuiButton-outlinedPrimary': {
      color: theme.mode === 'light' ? '#00BFFF' : '#FFF',
      border: theme.mode === 'light' ? '1px solid rgba(0 124 102)' : '1px solid rgba(255, 255, 255, 0.5)',
    },
    '& .MuiTab-textColorPrimary.Mui-selected': {
      color: theme.mode === 'light' ? '#00BFFF' : '#FFF',
    }
  },
  avatar: {
    width: "100%",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    color: theme.palette.dark.main,
    background: theme.palette.barraSuperior,
    minHeight: "58px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 6px",
    minHeight: "44px",
    [theme.breakpoints.down("sm")]: {
      height: "44px",
      justifyContent: "flex-start", // Centraliza horizontalmente
    }
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 2,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    // width: `calc(100% - ${drawerWidth}px)`,
    width: "100%",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  menuButton: {
    marginRight: 21,
  }, 
  title: {
    flexGrow: 1,
    fontSize: 14,
    color: "white",
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    },
    ...theme.scrollbarStylesSoft
  },
  drawerPaperClose: {
    overflowX: "hidden",
    //paddingLeft: 10,    
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 88,
    [theme.breakpoints.up("sm")]: {
      width: 88,
    },
    [theme.breakpoints.down("sm")]: {
      width: 88
    }
  },
  appBarSpacer: {
    minHeight: "58px",
  },
  content: {
    flex: 1,
    overflow: "auto",
    // 👇 ESTILO DA SCROLLBAR PERSONALIZADA (IGUAL AO MENU)
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.grey[500],
      borderRadius: "4px",
      border: "2px solid transparent", // Para suavizar bordas (opcional)
      backgroundClip: "padding-box",
    },
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column"
  },
  containerWithScroll: {
    listStyle: "none",
    margin: "54px 0 0", // mantém o espaçamento superior de 54px
    padding: "8px 0",
    position: "relative",
    height: "calc(100vh - 54px)", // altura ajustada para respeitar o espaço do menu superior
    [theme.breakpoints.down("sm")]: {
      margin: "0px 0 0", // remove o espaçamento em telas pequenas
      height: "100%", // ocupa toda a altura disponível
    },
  },   
  NotificationsPopOver: {
    // color: theme.barraSuperior.secondary.main,
  },
  logo: {
    width: "60%",
    height: "auto",
    maxWidth: 200,
    objectFit: "contain",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
      maxWidth: 180,
      height: "auto",
      marginTop: 10,
    },
    transition: "width 0.3s ease",
  },
  userAvatar: {
    width: 32,
    height: 32,
    fontSize: "0.85rem",
    backgroundColor: "rgba(255,255,255,0.25)",
    color: "#fff",
    cursor: "pointer",
    border: "2px solid rgba(255,255,255,0.4)",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.35)",
    },
  },
  mobileToolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "& > *": {
      flexShrink: 0,
    },
  },
  menuButtonHidden: {
    [theme.breakpoints.up("sm")]: {
      display: "none", // Esconde somente quando o Drawer está aberto em telas maiores
    },
  },
  hideOnDesktop: {
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  hideOnMobile: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
}));

const LoggedInLayout = ({ children, themeToggle }) => {
  const classes = useStyles();
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const { handleLogout, loading, licenseExpired, clearLicenseExpired } = useContext(AuthContext);
  const [drawerOpen, setDrawerOpen] = useState(() => window.innerWidth >= 600);
  const [drawerVariant, setDrawerVariant] = useState("permanent");
  // const [dueDate, setDueDate] = useState("");
  const { user } = useContext(AuthContext);

  const theme = useTheme();
  const { colorMode } = useContext(ColorModeContext);
  const smallerThenSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const [volume, setVolume] = useState(localStorage.getItem("volume") || 1);

  const isDarkMode = theme.palette.type === 'dark';
  const logoImagem = isDarkMode ? logoWhite : logo;

  const [companyDueDate, setCompanyDueDate] = useState(null);
  const [companyCreatedAt, setCompanyCreatedAt] = useState(null);
  const [bannerDismissed, setBannerDismissed] = useState(false);
  const toastFiredRef = useRef(false);
  const { finding } = useCompanies();

  // true enquanto a empresa tiver ≤ 7 dias de vida (período de trial)
  const isInTrial = companyCreatedAt
    ? moment().diff(moment(companyCreatedAt), "days") <= 7
    : false;
  const trialDay = companyCreatedAt
    ? moment().diff(moment(companyCreatedAt), "days") + 1
    : null;

  // Calcula o nível de urgência com base nos dias restantes
  const getLicenseState = () => {
    if (!companyDueDate) return null;
    // Comparar por dia-calendário (assim como as faturas e o banner já fazem),
    // evitando que a hora do dia desloque o limite de bloqueio. Tolerância de
    // 3 dias após o vencimento: dias -1, -2 e -3 só exibem aviso; a partir de
    // -4 (4º dia) a tela /blocked é acionada.
    const days = companyDueDate
      .clone()
      .startOf("day")
      .diff(moment().startOf("day"), "days");
    if (days < -3) return { level: "blocked",  days, color: "#c62828", bg: "#b71c1c" };
    if (days < 0)  return { level: "expired",  days, color: "#c62828", bg: "#b71c1c" };
    if (days <= 1) return { level: "critical", days, color: "#e53935", bg: "#c62828" };
    if (days <= 3) return { level: "urgent",   days, color: "#e65100", bg: "#bf360c" };
    // Aviso antecipado (4–7 dias) só para licenças pagas. Durante o trial não
    // exibimos a faixa logo no início — ela confunde quem está testando pela
    // primeira vez; aparece só nos últimos dias (urgent/critical acima).
    if (days <= 7 && !isInTrial) return { level: "warning", days, color: "#f57f17", bg: "#e65100" };
    return null;
  };

  const licenseState = getLicenseState();

  // Banner visível se: há estado de urgência E não foi dispensado (exceto expirada — nunca some)
  const isHardExpired = licenseState?.level === "expired" || licenseState?.level === "blocked";
  const showLicenseBanner = licenseState && (isHardExpired || !bannerDismissed);

  useEffect(() => {
    const loadCompanyDueDate = async () => {
      if (!user?.companyId) return;
      try {
        const company = await finding(user.companyId);
        setCompanyDueDate(company.dueDate ? moment(company.dueDate) : null);
        setCompanyCreatedAt(company.createdAt || null);
      } catch (err) {
        console.error("Erro ao carregar dados da empresa", err);
      }
    };
    loadCompanyDueDate();
  }, [user?.companyId]);

  // Toast único por sessão quando urgente ou crítico
  useEffect(() => {
    if (!licenseState || toastFiredRef.current) return;
    if (licenseState.level === "urgent" || licenseState.level === "critical") {
      toastFiredRef.current = true;
      const days = licenseState.days;
      toast.warning(
        days <= 1
          ? "⚠️ Sua licença vence amanhã! Renove agora para não perder o acesso."
          : `⚠️ Sua licença vence em ${days} dias. Acesse Financeiro para renovar.`,
        { toastId: "license-warning", autoClose: 8000 }
      );
    }
  }, [licenseState]);

  // Controle de fechar banner — expirada não pode fechar
  const handleCloseBanner = () => {
    if (isHardExpired) return;
    setBannerDismissed(true);
    localStorage.setItem("licenseBannerClosedAt", Date.now().toString());
  };

  // Restaura estado dismissed com base no localStorage
  useEffect(() => {
    if (!licenseState) return;
    if (isHardExpired) {
      setBannerDismissed(false);
      return;
    }
    const closedAt = localStorage.getItem("licenseBannerClosedAt");
    if (closedAt) {
      const hoursPassed = (Date.now() - parseInt(closedAt)) / (1000 * 60 * 60);
      const limit = licenseState.level === "critical" ? 4 : 24;
      setBannerDismissed(hoursPassed < limit);
    }
  }, [companyDueDate]);


  useEffect(() => {
    // No mobile, abre o drawer só nos passos que apontam para o menu lateral;
    // nos demais mantém fechado para o foco não cair atrás do overlay do menu.
    const onStep = (e) => {
      if (window.innerWidth >= 600) return;
      setDrawerOpen(!!(e.detail && e.detail.needsDrawer));
    };
    const onFinish = () => { if (window.innerWidth < 600) setDrawerOpen(false); };
    window.addEventListener("guidedtour:step", onStep);
    window.addEventListener("guidedtour:finish", onFinish);
    return () => {
      window.removeEventListener("guidedtour:step", onStep);
      window.removeEventListener("guidedtour:finish", onFinish);
    };
  }, []);

  useEffect(() => {
    const isMobileOrTablet = smallerThenSm || isTablet;
    setDrawerVariant(isMobileOrTablet ? "temporary" : "permanent");
    if (isMobileOrTablet) setDrawerOpen(false);
  }, [smallerThenSm, isTablet]);

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const userId = localStorage.getItem("userId");

    const socket = socketConnection({ companyId });

    socket.on(`company-${companyId}-auth`, (data) => {
      if (data.user.id === +userId) {
        toastError("Sua conta foi acessada em outro computador.");
        setTimeout(() => {
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    });

    socket.emit("userStatus");
    const interval = setInterval(() => {
      socket.emit("userStatus");
    }, 1000 * 60 * 5);

    return () => {
      socket.disconnect();
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const history = useHistory();
  const location = useLocation();

  // Recuperação após pagamento: quando o backend confirma o pagamento, atualiza
  // o vencimento em memória para que a tela de bloqueio suma sem exigir reload.
  useEffect(() => {
    if (!user?.companyId) return;
    const socket = socketConnection({ companyId: user.companyId });
    socket.on(`company-${user.companyId}-payment`, (data) => {
      if (data?.company?.dueDate) {
        setCompanyDueDate(moment(data.company.dueDate));
      }
      // Pagamento confirmado: remove o bloqueio sem exigir reload.
      if (clearLicenseExpired) clearLicenseExpired();
    });
    return () => socket.disconnect();
  }, [user?.companyId, clearLicenseExpired]);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const handleOpenUserModal = () => {
    setUserModalOpen(true);
    handleCloseMenu();
  };

  const handleClickLogout = () => {
    handleCloseMenu();
    handleLogout();
  };

  const drawerClose = () => {
    if (smallerThenSm || isTablet) {
      setDrawerOpen(false);
    }
  };

  const handleMenuItemClick = () => {
    if (smallerThenSm || isTablet) {
      setDrawerOpen(false);
    }
  };

  const toggleColorMode = () => {
    colorMode.toggleColorMode();
  }

  if (loading) {
    return <BackdropLoading />;
  }

  // Licença vencida: renderiza a tela de bloqueio no lugar do app, SEM trocar de
  // rota (evita o ping-pong /blocked → /login → /). O gatilho principal é o
  // sinal autoritativo do backend (402 ERR_LICENSE_EXPIRED); o cálculo local do
  // vencimento serve de reforço. O Financeiro segue acessível para pagamento.
  const isBlocked = licenseExpired || licenseState?.level === "blocked";
  if (isBlocked && location.pathname !== "/financeiro") {
    return <Blocked />;
  }

  return (
    <div className={classes.root}>
      <UserModal open={userModalOpen} onClose={() => setUserModalOpen(false)}userId={user?.id} />
      
      {showLicenseBanner && licenseState && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 1400,
          backgroundColor: licenseState.bg,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 16px",
          minHeight: 36,
          gap: 12,
          boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
        }}>
          {/* Texto */}
          <Typography
            variant="body2"
            style={{
              color: "#fff",
              flex: 1,
              fontWeight: isHardExpired ? 700 : 500,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {licenseState.level === "blocked" && (
              smallerThenSm
                ? <>🔴 <strong>Acesso suspenso!</strong> Renove sua licença.</>
                : <>🔴 <strong>Acesso suspenso!</strong> Sua licença venceu em <strong>{companyDueDate.format("DD/MM/YYYY")}</strong>. Renove para reativar o sistema.</>
            )}
            {licenseState.level === "expired" && (
              smallerThenSm
                ? <>🔴 <strong>Licença expirada!</strong> Venceu em {companyDueDate.format("DD/MM")}.</>
                : <>🔴 <strong>Licença expirada!</strong> Sua assinatura venceu em <strong>{companyDueDate.format("DD/MM/YYYY")}</strong>. Renove em até 3 dias para evitar bloqueio.</>
            )}
            {licenseState.level === "critical" && (
              isInTrial
                ? smallerThenSm
                  ? <>⏰ <strong>Último dia de trial!</strong> Assine para não perder o acesso.</>
                  : <>⏰ <strong>Último dia do seu período gratuito!</strong> Assine agora e continue atendendo sem interrupção.</>
                : smallerThenSm
                  ? <>🟠 <strong>Vence amanhã!</strong> Renove agora.</>
                  : <>🟠 <strong>Atenção!</strong> Sua licença vence <strong>amanhã ({companyDueDate.format("DD/MM/YYYY")})</strong>. Renove para não perder o acesso.</>
            )}
            {licenseState.level === "urgent" && (
              isInTrial
                ? smallerThenSm
                  ? <>🎯 Trial: <strong>{licenseState.days} dias</strong> restantes. Gostou?</>
                  : <>🎯 Faltam <strong>{licenseState.days} dias</strong> do seu trial gratuito. Gostou do sistema? Assine agora com acesso completo.</>
                : smallerThenSm
                  ? <>🟡 Vence em <strong>{licenseState.days} dias</strong>.</>
                  : <>🟡 Sua licença vence em <strong>{licenseState.days} dias ({companyDueDate.format("DD/MM/YYYY")})</strong>. Renove antecipadamente.</>
            )}
            {licenseState.level === "warning" && (
              isInTrial
                ? trialDay <= 2
                  ? smallerThenSm
                    ? <>👋 <strong>Bem-vindo!</strong> Conecte seu WhatsApp para começar.</>
                    : <>👋 <strong>Bem-vindo ao Message Express!</strong> Você tem {licenseState.days} dias grátis. Conecte seu WhatsApp e comece a atender agora.</>
                  : trialDay <= 4
                    ? smallerThenSm
                      ? <>💡 Explore o Kanban e as filas de atendimento.</>
                      : <>💡 <strong>Dica do dia {trialDay}:</strong> Organize seu time com filas de departamento e acompanhe atendimentos no Kanban.</>
                    : smallerThenSm
                      ? <>✨ Trial: <strong>{licenseState.days} dias</strong> restantes. Assine agora.</>
                      : <>✨ Seu trial vai até <strong>{companyDueDate.format("DD/MM/YYYY")}</strong>. Está gostando? Assine agora e continue sem interrupções.</>
                : smallerThenSm
                  ? <>Licença vence em <strong>{licenseState.days} dias</strong>.</>
                  : <>Sua licença vence em <strong>{licenseState.days} dias ({companyDueDate.format("DD/MM/YYYY")})</strong>. Considere renovar em breve.</>
            )}
          </Typography>

          {/* Botão Renovar */}
          <Button
            size="small"
            variant="contained"
            onClick={() => history.push("/financeiro?tab=faturas")}
            style={{
              backgroundColor: "#fff",
              color: licenseState.bg,
              fontWeight: 700,
              fontSize: "0.72rem",
              padding: "2px 12px",
              flexShrink: 0,
              whiteSpace: "nowrap",
              boxShadow: "none",
            }}
          >
            Renovar agora
          </Button>

          {/* Fechar — apenas quando não expirada */}
          {!isHardExpired && (
            <IconButton
              size="small"
              onClick={handleCloseBanner}
              style={{ color: "#fff", flexShrink: 0, padding: 4 }}
            >
              <CloseIcon style={{ fontSize: 16 }} />
            </IconButton>
          )}
        </div>
      )}

      <AppBar
        position="fixed"
        className={clsx(classes.appBar, drawerOpen && classes.appBarShift)}
        color="primary"
        style={{
          top: showLicenseBanner ? 32 : 0, // ← EMPURRA O APPBAR PARA BAIXO SE A FAIXA ESTIVER VISÍVEL
        }}
      >
        <Toolbar variant="dense" className={classes.toolbar}>
          {/* Hambúrguer */}
          <Tooltip title={drawerOpen ? "Fechar menu" : "Abrir menu"} placement="bottom">
            <IconButton
              edge="start"
              onClick={() => setDrawerOpen(!drawerOpen)}
              className={classes.menuButton}
              color="inherit"
            >
              {drawerOpen
                ? <MenuOpen style={{ color: "white" }} />
                : <MenuIcon style={{ color: "white" }} />}
            </IconButton>
          </Tooltip>

          {/* Logo centralizada */}
          <img
            src={logoImagem}
            className={classes.logo}
            alt="logo"
            style={{ maxHeight: 40 }}
          />

          {/* Espaço flexível */}
          <div style={{ flex: 1 }} />

          {/* Ícones à direita */}
          <div className={classes.rightSection}>
            <Tooltip title="Comunicados" placement="bottom">
              <span><AnnouncementsPopover /></span>
            </Tooltip>

            <Tooltip title="Notificações" placement="bottom">
              <span>{user.id && <NotificationsPopOver volume={volume} />}</span>
            </Tooltip>

            <Tooltip title="Chat interno" placement="bottom">
              <span><ChatPopover /></span>
            </Tooltip>

            {/* Avatar do usuário logado */}
            <Tooltip title={`${user?.name || "Minha conta"} — clique para opções`} placement="bottom">
              <Avatar
                className={classes.userAvatar}
                onClick={handleMenu}
                style={{ marginLeft: 8 }}
              >
                {user?.name?.charAt(0).toUpperCase() || "?"}
              </Avatar>
            </Tooltip>

            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              open={menuOpen}
              onClose={handleCloseMenu}
            >
              <MenuItem disabled style={{ opacity: 1, paddingBottom: 4 }}>
                <div>
                  <Typography variant="body2" style={{ fontWeight: 600 }}>
                    {user?.name}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {user?.email}
                  </Typography>
                </div>
              </MenuItem>
              <Divider />
              <MenuItem onClick={handleOpenUserModal}>
                {i18n.t("mainDrawer.appBar.user.profile")}
              </MenuItem>
              <MenuItem onClick={handleClickLogout}>
                {i18n.t("mainDrawer.appBar.user.logout")}
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      <Drawer
        variant={drawerVariant}
        className={drawerOpen ? classes.drawerPaper : classes.drawerPaperClose}
        classes={{
          paper: clsx(
            classes.drawerPaper,
            !drawerOpen && classes.drawerPaperClose
          ),
        }}
        open={drawerOpen}
        style={{
          marginTop: showLicenseBanner ? 32 : 0, // ← EMPURRA O DRAWER PARA BAIXO
        }}
      >        
        <div className={classes.hideOnDesktop}>
          <div className={classes.toolbarIcon}>
            <div style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}>
              {/* <img src={logoImagem} className={classes.logo} alt="logo" /> */}
            </div>
            <IconButton 
              onClick={() => setDrawerOpen(!drawerOpen)}            
            >
              <ChevronLeftIcon />
            </IconButton>
          </div>
        </div>

        {/* <Divider /> */}
        <List className={classes.containerWithScroll}>
          <MainListItems drawerClose={drawerClose} collapsed={!drawerOpen} volume={volume} setVolume={setVolume} onOpenUserModal={handleOpenUserModal} />
        </List>
        {/* <Divider /> */}
      </Drawer>

      <main className={classes.content}>
        <div className={classes.appBarSpacer}
          style={{
            minHeight: showLicenseBanner ? 122 : 58,
          }}
        />
        {children ? children : null}
      </main>

      {/* Botão de ajuda flutuante — oculto em rotas com barra de envio */}
      {!["/tickets", "/chats"].some(p => location.pathname.startsWith(p)) && (
      <Tooltip title="Central de Ajuda" placement="left">
        <div
          onClick={() => history.push("/helps")}
          style={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 1300,
            width: 44,
            height: 44,
            borderRadius: "50%",
            backgroundColor: "#1976d2",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            transition: "transform 0.15s, box-shadow 0.15s",
          }}
          onMouseEnter={e => {
            e.currentTarget.style.transform = "scale(1.1)";
            e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.3)";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.25)";
          }}
        >
          <HelpOutlineIcon style={{ fontSize: 22 }} />
        </div>
      </Tooltip>
      )}
    </div>
  );
};

export default LoggedInLayout;